/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-undef */
import 'regenerator-runtime/runtime'
import _ from 'lodash'
// import { put } from 'redux-saga/effects'
// import onTokenUpdate from './onTokenUpdate'

function* onSignInSuccess(action) {
  const token = _.get(action, 'payload.tokens.RefreshToken', null)

  if (_.get(action, 'meta.remember', false) && token) {
    localStorage.setItem('user_token', token)
  }

  const accessToken = _.get(action, 'payload.token', null)

  if (accessToken) {
    localStorage.setItem('access', accessToken)
    localStorage.setItem('role', action.payload.role)
    localStorage.setItem('isArtist', action.payload.isArtist)
  }

  const user = _.get(action, 'payload.user', {})

  if (action.payload.user) {
    localStorage.setItem('user', JSON.stringify(user))
  }

  yield true
}

export default onSignInSuccess
